export default __webpack_public_path__ + "static/media/opensans-light.258fdd11.woff";